__turbopack_context__.v({
  "contentWrapper": "RecommendedItinerary-module__V_BsJG__contentWrapper",
  "cta": "RecommendedItinerary-module__V_BsJG__cta",
  "highlight": "RecommendedItinerary-module__V_BsJG__highlight",
  "imageWrapper": "RecommendedItinerary-module__V_BsJG__imageWrapper",
  "picture": "RecommendedItinerary-module__V_BsJG__picture",
  "recommendedSection": "RecommendedItinerary-module__V_BsJG__recommendedSection",
  "subtitle": "RecommendedItinerary-module__V_BsJG__subtitle",
  "title": "RecommendedItinerary-module__V_BsJG__title",
  "wishListButton": "RecommendedItinerary-module__V_BsJG__wishListButton",
  "wrapper": "RecommendedItinerary-module__V_BsJG__wrapper",
});
